document.addEventListener('click', async (e) => {
  const btn = e.target.closest('.js-lc-add');
  if (!btn) return;

  const id = Number(btn.dataset.variantId);
  const original = btn.textContent;
  btn.disabled = true;

  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id, quantity: 1 }] })
    });
    if (!res.ok) throw new Error();

    btn.textContent = 'Added ✓';
    document.dispatchEvent(new CustomEvent('cart:refresh')); // opens/refreshes cart drawer in Spotlight
  } catch (err) {
    window.location.href = btn.getAttribute('data-product-url');
  } finally {
    setTimeout(() => { btn.textContent = original; btn.disabled = false; }, 1200);
  }
});
